import { render, staticRenderFns } from "./AssignPermissionPage.vue?vue&type=template&id=7f48bc60&scoped=true&"
import script from "./AssignPermissionPage.vue?vue&type=script&lang=js&"
export * from "./AssignPermissionPage.vue?vue&type=script&lang=js&"
import style0 from "./AssignPermissionPage.vue?vue&type=style&index=0&id=7f48bc60&prod&lang=scss&scoped=true&"
import style1 from "./AssignPermissionPage.vue?vue&type=style&index=1&id=7f48bc60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48bc60",
  null
  
)

export default component.exports